<template>
  <div class="price-info-card">
    <h1 class="price-info-card__book-name">{{priceInfo.name}}</h1>
     <div
      class="price-info-card__detail unlimited-tag"
      v-if="priceInfo.is_unlimited===1"
    >
      <img class="unlimited-img" src="../../../../static/img/unlimited-tag.png" alt="">
    </div>
    <div class="price-info-card__detail" v-if="priceInfo.author">
      <span class="title">筆者：</span>
      {{priceInfo.author}}
    </div>
    <div class="price-info-card__detail">
      <span class="title">価格：</span>
      ¥{{priceInfo.price_jp.toLocaleString()}}{{dashIfRequired}} 税別
    </div>
    <div class="price-info-card__detail" v-if="priceInfo.publisher">
      <span class="title">出版社：</span>
      {{priceInfo.publisher}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    priceInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkUunlimited(bool) {
      return bool ? "対象" : "対象外";
    }
  },
  computed: {
    dashIfRequired() {
      return this.priceInfo.need_dash ? "〜" : "";
    }
  },

};
</script>


<style lang="scss" scoped>
$base-font-size: 16px;
.price-info-card {
  border: 1px solid black;
  text-align: left;
  padding: 10px;
  background-color: #fff;
  margin: 10px 0;
  @media screen and (max-width: 768px) {
    margin: 10px;
  }
  &__book-name {
    font-weight: bold;
    font-size: $base-font-size;
    color: #ff5b60;
  }
  .not-unlimited {
    color: #ff5b60;
  }
  .is-unlimited {
    color: green;
  }
}
.title {
  font-weight: bold;
}
.unlimited-tag{
  margin: 0 0 5px;
}
.unlimited-img{
  height: 20px;
}
</style> 



// WEBPACK FOOTER //
// src/components/priceList/parts/PriceInfoCard.vue